/** @prettier */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { settledBetsRequest, updateParams } from '@xanadu/ui-shared/modules/settledBets/actions';

import Settled from '../../../components/reports/Settled';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      settledBetsRequest,
      updateParams,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    product: state.getIn(['application', 'product']),
    currency: state.getIn(['user', 'currency']),
    oddsType: state.getIn(['user', 'oddsType']),
    sports: state.getIn(['lookups', 'sports']),
    events: state.getIn(['settledBets', 'reports', 'events']),
    markets: state.getIn(['settledBets', 'reports', 'markets']),
    selections: state.getIn(['settledBets', 'reports', 'selections']),
    netProfitAndLoss: state.getIn(['settledBets', 'reports', 'netProfitAndLoss']),
    bets: state.getIn(['settledBets', 'reports', 'bets']),
    total: state.getIn(['settledBets', 'reports', 'total']),
    params: state.getIn(['settledBets', 'reports', 'params']),
    error: state.getIn(['settledBets', 'reports', 'error']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settled));
